// extracted by mini-css-extract-plugin
export var active = "_aq-d";
export var blink = "_aq-e";
export var container = "_aq-5";
export var controls = "_aq-0";
export var controlsRight = "_aq-1";
export var fakeCursor = "_aq-c";
export var hidden = "_aq-b";
export var quillContainerSmall = "_aq-7";
export var quillEditor = "_aq-6";
export var quillEditorSmall = "_aq-8";
export var quillFormatButtons = "_aq-a";
export var quillToolbar = "_aq-9";
export var removePadding = "_aq-2";
export var state = "_aq-3";
export var stateTitle = "_aq-4";